import { api } from '@/api/core';
import { handleQueryLifecycle } from '@/api/utils';

type GetLoginStatusResponse = object;

type GetLoginStatusProps = {
  abortController?: AbortController;
};

const getLoginStatusApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLoginStatus: builder.query<GetLoginStatusResponse, GetLoginStatusProps>({
      query: ({ abortController = new AbortController() }: GetLoginStatusProps) => ({
        url: `login/status`,
        method: 'GET',
        signal: abortController.signal,
      }),
      async onQueryStarted(_arg, { queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, () => {});
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetLoginStatusQuery } = getLoginStatusApi;
